import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ProfileEditForm from './ProfileEditForm';
import MovementSpecialistAdminNavigation from './MovementSpecialistAdminNavigation';
import SessionsPage from './sessions/MovementSpecialistAdminSessionsPage';
import StripeExpressLandingPage from './StripeExpressLandingPage';

import { hasMsAdminAccess, userIsMovementSpecialist } from '../redux/selectors';

class MovementSpecialistAdmin extends Component {
  render() {
    const { hasMsAdminAccess, match, userIsMovementSpecialist } = this.props;

    if (!hasMsAdminAccess) {
      return <Redirect to={`/`} />;
    }

    return (
      <div className="container">
        <Helmet>
          <title>Tathata Golf - MS Admin</title>
        </Helmet>
        <MovementSpecialistAdminNavigation userIsMovementSpecialist={userIsMovementSpecialist} />
        <Switch>
          <Route exact path={`${match.path}/profile`} component={ProfileEditForm} />
          {userIsMovementSpecialist && <Route exact path={`${match.path}/follow-ups`} component={SessionsPage} />}
          <Route exact path={`${match.path}/connect`} component={StripeExpressLandingPage} />
          <Redirect to={`${match.path}/profile`} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hasMsAdminAccess: hasMsAdminAccess(state),
  userIsMovementSpecialist: userIsMovementSpecialist(state),
});

export default connect(mapStateToProps)(MovementSpecialistAdmin);



// WEBPACK FOOTER //
// ./src/subscription/movement-specialist-admin/MovementSpecialistAdmin.js